module.exports = __webpack_public_path__ + "static/media/features-split-image-02.5f64eb31.jpg";